import dayjs from 'dayjs';
import { css } from 'styled-components';

export function getCssByXAlign(xAlign: 'left' | 'center' | 'right') {
  if (xAlign === 'right' || xAlign === 'center') {
    return css`
      transform: translate3d(-100%, -50%, 0);
      margin-left: -15px;

      &::before {
        left: auto;
        right: -7px;
        border-top: 6px solid transparent;
        border-bottom: 6px solid transparent;
        border-left: 7px solid ${({ theme }) => theme.colors.magenta700};
      }
    `;
  }

  return css`
    transform: translate3d(0, -50%, 0);
    margin-left: 15px;

    &::before {
      left: -7px;
      border-top: 6px solid transparent;
      border-bottom: 6px solid transparent;
      border-right: 7px solid ${({ theme }) => theme.colors.magenta700};
    }
  `;
}

export function getDateString(date: string) {
  if (!date) {
    return null;
  }

  if (date.indexOf('Q') >= 0) {
    return date;
  }

  return dayjs(date).format('YYYY.MM');
}
